/**
 * Arbitrage Query Keys
 *
 * React Query cache keys for arbitrage configurations.
 */

export const ARBITRAGE_QUERY_KEYS = {
  all: ['arbitrage-configs'] as const,
  lists: () => [...ARBITRAGE_QUERY_KEYS.all, 'list'] as const,
  listByProject: (projectId: number) => [...ARBITRAGE_QUERY_KEYS.lists(), projectId] as const,
} as const;
